import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import { adminApi } from '../lib/adminApi';

const TABS = [
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
  { key: '', label: 'All' },
];

const StatusPill = ({ s }) => {
  const map = { pending: 'bg-[#fff3cd] text-[#8a6d00]', approved: 'bg-[#d4f5df] text-[#1a7a3f]', rejected: 'bg-[#fde0e0] text-[#b42318]' };
  return <span className={`text-[10px] uppercase tracking-[0.15em] px-2 py-0.5 ${map[s] || 'bg-neutral-100'}`}>{s}</span>;
};

export default function AdminApplications() {
  const [tab, setTab] = useState('pending');
  const [data, setData] = useState({ applications: [], counts: {} });
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminApi.listApplications(tab)
      .then(setData)
      .catch(() => toast.error('Could not load applications'))
      .finally(() => setLoading(false));
  };
  useEffect(load, [tab]);

  return (
    <div data-testid="admin-applications-page" className="max-w-5xl">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Review Queue</div>
      <h1 className="mt-1 font-serif text-3xl md:text-4xl">New Artists</h1>
      <p className="mt-3 text-sm text-neutral-600">Review native registration applications, generate bios, then approve &amp; publish.</p>

      <div className="mt-8 flex gap-2 flex-wrap">
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`apps-tab-${t.label.toLowerCase()}`}
            className={`px-4 py-2 text-[10px] uppercase tracking-[0.2em] border transition-colors ${tab === t.key ? 'bg-[#eb5381] text-white border-[#eb5381]' : 'border-[#eaeaea] hover:border-[#eb5381]'}`}>
            {t.label}{t.key && data.counts?.[t.key] != null ? ` (${data.counts[t.key]})` : ''}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="py-16 flex justify-center text-neutral-400"><Loader2 className="w-5 h-5 animate-spin" /></div>
      ) : data.applications.length === 0 ? (
        <div className="mt-8 border border-dashed border-neutral-300 p-12 text-center text-sm text-neutral-500">No applications here yet.</div>
      ) : (
        <ul className="mt-6 space-y-2">
          {data.applications.map(a => (
            <li key={a.id}>
              <Link to={`/admin/applications/${a.id}`} data-testid={`app-row-${a.id}`}
                className="flex items-center gap-4 bg-white border border-[#eaeaea] p-4 hover:border-[#eb5381] transition-colors">
                <div className="w-12 h-12 bg-neutral-100 shrink-0 overflow-hidden">
                  {a.portfolio?.[0] && <img src={a.portfolio[0]} alt="" className="w-full h-full object-cover" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-serif text-lg leading-tight">{a.name}</div>
                  <div className="text-[11px] uppercase tracking-[0.15em] text-neutral-500">{a.city} · {a.email}</div>
                </div>
                <div className="text-right shrink-0">
                  <StatusPill s={a.status} />
                  <div className="text-[10px] text-neutral-400 mt-1">{(a.created_at || '').slice(0, 10)}</div>
                </div>
                <ChevronRight className="w-4 h-4 text-neutral-300" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
